<template>
  <v-app>
    <div class="auth">
      <div class="auth-box">
        <v-container fluid class="pa-0">
          <v-row no-gutters>
            <v-col cols="12" md="6">
              <img src="@/assets/images/main-logo-dt.png" class="auth-logo ma-5"/>
              <svg-icon class="auth-featured" :icon="img" width="568" height="592" />
            </v-col>
            <v-col cols="12" md="6">
              <div class="auth-form">
                <slot />
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
    <Notification />
  </v-app>
</template>

<script>
import Notification from '@/components/base/Notification';

export default {
  name: 'AuthBox',
  props: {
    auth: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    img() {
      return this.auth ? 'img-login' : 'img-forgot';
    }
  },
  components: {
    Notification
  }
};
</script>

<style lang="scss">

.auth-logo{
  width: 150px !important;
  height: 40px !important;
}
.auth-featured{
  height: 300px;
  position: absolute;
  bottom: -4px !important;
  left: -1px !important;
  z-index: 1;
}
.auth {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9e6c7;

  &-box {
    background-color: #00BF63;
    box-shadow: 0 21px 46px 0 rgba(0, 0, 0, 0.12);
    position: relative;
    overflow: hidden;
  }

  &-logo {
    height: 55px;
  }

  &-featured {
    height: 300px;
    position: absolute;
    bottom: 0;
    left: -10px;
    z-index: 1;
  }

  &-form {
    background-color: #ffffff;
    border-radius: 2px;
    z-index: 2;
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: 10px;
    padding: 20px;
  }

  &-title {
    color: #6d6d6d;
    font-family: Montserrat;
    font-size: 24px;
  }

  &-subtitle {
    color: #acacac;
    font-family: Montserrat;
    font-size: 12px;
    line-height: 14.63px;
    text-align: left;
  }

  &-forgot-password {
    text-decoration: none;
  }

  @media (min-width: 576px) {
    flex-direction: row;

    &-box {
      width: 996px;
      height: 592px;
      border-radius: 24px;
    }

    &-featured {
      width: auto;
      height: auto;
    }

    &-form {
      margin: 0;
      margin-top: 10px;
      margin-right: 10px;
      height: 570px;
      padding: 80px;
      border-radius: 24px;
    }
  }
}
</style>
